import { LocTagInvite } from 'src/types/LineOfCredit';

export function sortAscTagInvites(tagInvites: LocTagInvite[]): LocTagInvite[] {
  return tagInvites.sort((a, b) => a.name.localeCompare(b.name));
}
